module.exports = __webpack_public_path__ + "img/task-center-bg.b25f2cbc.png";